import React from 'react';
import i18n from '@i18n';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import BetListNg from './BetListNg';

function BetGroupNg({ name, ticket, bets }) {
    return (
        <>
            <div className="list-divider">
                <div className="group-name">
                    {i18n('ticketus.ticket.group')} {name}
                </div>
            </div>
            <BetListNg ticket={ticket} bets={bets} />
        </>
    );
}

BetGroupNg.propTypes = {
    name: PropTypes.string.isRequired,
    ticket: PropTypes.instanceOf(Immutable.Map),
    bets: PropTypes.instanceOf(Immutable.List)
};

export default BetGroupNg;
